"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateRequestDetector = void 0;
const object_code_1 = require("object-code");
const utils_1 = require("../utils");
class DuplicateRequestDetector {
    constructor() {
        this.onGoingRequestIds = [];
    }
    detect(request) {
        var _a, _b;
        const requestId = this.hashAxiosRequest(request);
        const hasOngoingId = this.onGoingRequestIds.includes(requestId);
        this.onGoingRequestIds.push(requestId);
        if (hasOngoingId) {
            const headers = request.headers;
            const activeOrgId = (_a = headers === null || headers === void 0 ? void 0 : headers["x-hhn-active-org-id"]) !== null && _a !== void 0 ? _a : null;
            const source = (_b = headers === null || headers === void 0 ? void 0 : headers["x-hhn-source"]) !== null && _b !== void 0 ? _b : null;
            throw new Error(`Panic: duplicate request detected: request id: ${requestId}, base url: ${request.baseURL}, url: ${request.url}, method: ${request.method}, params: ${JSON.stringify(request.params)}, data: ${JSON.stringify(request.data)}, active org id: ${activeOrgId}, source: ${source}`);
        }
    }
    clear(request) {
        const requestId = this.hashAxiosRequest(request);
        const index = this.onGoingRequestIds.indexOf(requestId);
        if (index === -1) {
            throw new Error(`Can't clear request id that is not present!!: ${request.url}, ${requestId}`);
        }
        this.onGoingRequestIds.splice(index, 1);
    }
    hashAxiosRequest(request) {
        var _a, _b, _c, _d;
        const normalizedBaseURL = (request.baseURL || "").replace(/\/+$/, "");
        const normalizedUrl = (request.url || "").replace(/^\/+/, "");
        const normalizedMethod = (request.method || "get").toLowerCase();
        const finalUrl = normalizedBaseURL && normalizedUrl
            ? `${normalizedBaseURL}/${normalizedUrl}`
            : normalizedBaseURL || normalizedUrl;
        const headers = request.headers;
        // Include org-specific header in hash to differentiate requests for different orgs
        const activeOrgId = (_a = headers === null || headers === void 0 ? void 0 : headers["x-hhn-active-org-id"]) !== null && _a !== void 0 ? _a : null;
        const source = (_b = headers === null || headers === void 0 ? void 0 : headers["x-hhn-source"]) !== null && _b !== void 0 ? _b : null;
        const keyObj = {
            url: finalUrl,
            method: normalizedMethod,
            params: (_c = request.params) !== null && _c !== void 0 ? _c : null,
            // Axios request intereceptor has the request.data as string while response interceptor has it as an object.
            // Hence we are normaizing the data to object.
            data: (_d = (0, utils_1.safeJsonSerialize)(request.data)) !== null && _d !== void 0 ? _d : null,
            activeOrgId,
            source,
        };
        const finalHash = `${(0, object_code_1.hash)(keyObj)}`;
        return finalHash;
    }
}
exports.DuplicateRequestDetector = DuplicateRequestDetector;
